import React, { useState, useEffect, CSSProperties } from 'react';
import { Hidden } from '@material-ui/core';
import { StepMarkerStatus } from './StepMarker';
import StepsNavigationMobile from './StepsNavigationMobile';
import StepsNavigationDesktop from './StepsNavigationDesktop';

export interface StepsNavigationProps {
  className?: string;
  currentStep?: number;
  totalSteps: number;
  onBack?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
  style?: CSSProperties;
  valid?: boolean;
}

const StepsNavigation = (props: StepsNavigationProps) => {
  const { currentStep = 1, totalSteps } = props;
  const [_currentStep, _setCurrentStep] = useState(currentStep);

  useEffect(() => {
    _setCurrentStep(currentStep);
  }, [currentStep]);

  const stepStatuses: StepMarkerStatus[] = [...Array(totalSteps)].map(
    (_, index) => {
      if (_currentStep === index + 1) {
        return 'active';
      } else if (_currentStep > index + 1) {
        return 'completed';
      }

      return 'inactive';
    },
  );

  const handleBack = () => {
    if (_currentStep === 1) {
      return;
    }

    _setCurrentStep(_currentStep - 1);

    if (typeof props.onBack === 'function') {
      props.onBack();
    }
  };

  const handleNext = () => {
    _setCurrentStep(_currentStep + 1);

    if (typeof props.onNext === 'function') {
      props.onNext();
    }
  };

  const handleSubmit = () => {
    if (typeof props.onSubmit === 'function') {
      props.onSubmit();
    }
  };

  return (
    <>
      <Hidden smDown implementation="css">
        <StepsNavigationDesktop
          {...props}
          onBack={handleBack}
          onNext={handleNext}
          onSubmit={handleSubmit}
          stepStatuses={stepStatuses}
          currentStep={_currentStep}
        />
      </Hidden>
      <Hidden mdUp implementation="css">
        <StepsNavigationMobile
          {...props}
          onBack={handleBack}
          onNext={handleNext}
          onSubmit={handleSubmit}
          stepStatuses={stepStatuses}
          currentStep={_currentStep}
        />
      </Hidden>
    </>
  );
};

export default StepsNavigation;
